import { get, post, put } from '.';

export function isAssignNextInboundCallEmpty(data: unknown): boolean {
	const ccq = (data as { call_communication_queue?: { id?: number } })?.call_communication_queue;
	return !(ccq?.id > 0);
}

export function AcceptIncomingCall(id: string, options = {}) {
	return post<any>("/app/api/call_communication_queues/" + (id || 0).toString() + "/accept", options);
}

export function AssignNextInboundCall(options = {}) {
	return put<any>("/app/api/call_communication_queues/next", options);
}

export function DeclineIncomingCall(id: string, options = {}) {
	return post<any>("/app/api/call_communication_queues/" + (id || 0).toString() + "/decline", options);
}

export function GetCallsWaiting(options = {}) {
	return get<any>("/app/api/call_communication_queues/waiting", options);
}

export function ReclaimNextInboundOffer(options = {}) {
	return put<any>("/app/api/call_communication_queues/reclaim", options);
}

export function ClearStuckCallCallQueue(id:string, options = {}) {
	return put<any>(`/app/api/call_communication_queues/${id}/clear`, options);
}

export function TakeCallWaitingFromLiveDashboard(id, options = {}) {
	return put<any>("/app/api/call_communication_queues/" +  (id || 0).toString()  + "/take_from_live_dashboard", options);
}
